import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import * as Yup from 'yup'
import { useMutation, useQuery } from '@apollo/client'
import { useLoading } from '../../../../../../LoadingOverlay/LoadingOverlayContext'
import Box from '../../../../../Global/Box'
import InputController from '../../../../../Global/InputController'
import { toastSweetAlert } from '../../../../../Helpers/ToastSweetAlert'
import { BoxItemData } from '../StatusDetails'
import {
  CREATE_STATUS_ROLE_VISIBILITY,
  GET_ALL_ROLES_AVAILABLE_TO_STATUS_ROLES_VISIBILITY,
} from '../../../../../../graphql/Catalog/Status/statusRoleVisibility'

const validationSchema = Yup.object().shape({
  role_id: Yup.string().nullable().required('Campo requerido'),
})

const StatusRolesAdd = ({ current_status_id, refetchMain, setCloseModal }) => {
  const { showLoading, hideLoading } = useLoading()
  const [optionsRoles, setOptionsRoles] = useState([])
  const [roleSelected, setRoleSelected] = useState(null)

  const {
    methods,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const {
    loading: loadingRoles,
    error: errorRoles,
    data: dataRoles,
    refetch: refetchRoles,
  } = useQuery(GET_ALL_ROLES_AVAILABLE_TO_STATUS_ROLES_VISIBILITY, {
    variables: { status_id: current_status_id },
    fetchPolicy: 'network-only',
  })

  const [create] = useMutation(CREATE_STATUS_ROLE_VISIBILITY)

  useEffect(() => {
    try {
      if (loadingRoles) return
      if (errorRoles) throw errorRoles
      if (!dataRoles) throw new Error('No se encontraron datos de los estados')
      const list = dataRoles.getAllRolesAvailabesNotInStatusRolesVisibility.map(
        (item) => ({ value: item.id, label: item.role_name, item })
      )
      setOptionsRoles(list)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }, [loadingRoles, errorRoles, dataRoles])

  const onSubmit = async (Data) => {
    showLoading()
    try {
      await create({
        variables: {
          status_id: current_status_id,
          role_id: parseInt(Data.role_id),
        },
      })

      toastSweetAlert({
        mode: 'ok',
        message: 'Relacion con rol creada correctamente',
      })
      setRoleSelected(null)
      setValue('role_id', null)
      await refetchRoles()
      await refetchMain()
      return setCloseModal(true)
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={'Agregar relacion de rol a estatus'}
            btnSubmit
            btnSubmitText={'Agregar'}
            errors={errors}
            content={
              <>
                <div className="row">
                  <div className="col-lg-6">
                    <InputController
                      name="role_id"
                      label="Roles"
                      control={control}
                      inputType="choosen"
                      options={optionsRoles}
                      menuPosition="fixed"
                      placeholderTxt="Selecciona un rol"
                      changeAction={(e) => setRoleSelected(e)}
                      value={roleSelected?.id}
                      isClearable={true}
                    />
                  </div>
                </div>
                {roleSelected && (
                  <div className="row mt-3">
                    <div className="col-12">
                      <div>
                        <b>Informacion del status seleccionado</b>
                      </div>
                      <div
                        className="d-flex flex-column flex-wrap"
                        style={{ gap: '5px' }}
                      >
                        <BoxItemData
                          title="NOMBRE"
                          value={roleSelected.item?.role_name}
                        />
                        <BoxItemData
                          title="DESCRIPCION"
                          value={roleSelected.item?.description}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}

export default StatusRolesAdd
